import { useState, useEffect } from "react";
import { useAuth } from "../../context/auth";
import { Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner";

export default function PrivateRoute() {
  const [ok, setOk] = useState(false);
  const [auth] = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const authCheck = async () => {
      try {
        const res = await axios.get("/api/v1/auth/user-auth");
        if (res.data.ok) {
          setOk(true);
        } else {
          setOk(false);
        }
      } catch (error) {
        setOk(false);
      }
    };
    if (auth?.token && auth?.user?.role === 0) {
      authCheck();
    } else if (auth?.token && auth?.user?.role === 1) {
      navigate("/dashboard/admin", { replace: true });
    }
  }, [auth?.token, auth?.user?.role, navigate]);

  return ok ? <Outlet /> : <Spinner />;
}
